import { useQuery } from "@tanstack/react-query";
import { getAllQuestionnaires } from "../../services/questionnaires";


const useGetQuestionnaires = () => {
    return useQuery({
        queryKey: ["questionnaires"],
        queryFn: getAllQuestionnaires,
        staleTime: Infinity,
    });
}

export default useGetQuestionnaires;